import React, { useState} from "react";
import {
    BUTTON,
    MODAL_CANCEL_TEXT,
    QUES_BANK_CLOSE,
    QUESTION_BANK_MODAL,
    TEXTBOX,
    END_NOW_MULTI_OPTIONS_TEXT,
    END_NOW_OPTIONS_TEXT,
    ENTIRE_POLL_TEXT,
    CURRENT_QUESTION_TEXT,
    END_NOW_DESCRIPTION_MULTI_OPTIONS,
    FINISH_TEXT,
    POLL_TYPE,
    FINISH_POLL,
    FINISH_ATTENDANCE,
    FINISH_POLL_DESCRIPTION,
    FINISH_ATTENDANCE_DESCRIPTION,
    POLL_SHARE_MODE,
    QUESTION_TEXT,
    MODAL_CLOSE_TEXT
} from "../../utils/constants";
import {Modal} from "react-bootstrap";
import YuJaButton from "../standardization/YuJaButton";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import {YuJaRadioBox} from "../standardization/YuJaRadiobox";
import classes from "../../pages/ReleaseActivityPage/ReleaseActivityPage.module.css";
import settingsClasses from "../../pages/PlatformSetting/Settings.module.css";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import {useParams} from "react-router-dom";


export default function EndPollModal({setModalShow, show, localState, poll, handleStop, handleStopAll}) {
    const {isPPTPage} = usePPTWebView();
    const { serialNo } = useParams();

    const OPTIONS = {POLL: "POLL", QUESTION: "QUESTION"}
    const [selectedOpt, setSelectedOpt] = useState(OPTIONS.QUESTION);
    const [isSaving, setIsSaving] = useState(false);

    let isSharing = poll.pollType !== POLL_TYPE.ATTENDANCE && (localState === "GET_READY" || localState === "SHARED");

    const handleClose = () =>{
        setModalShow(false);
    };




    const handleSave = async () => {
        setIsSaving(true);
        try {
            if (isSharing) {
                if (selectedOpt === OPTIONS.QUESTION) {
                    await handleStop();
                } else {
                    await handleStop(true);
                }
            } else {
                if (poll.pollType === POLL_TYPE.ATTENDANCE) {
                    await handleStop();
                } else if (poll.pollShareMode === POLL_SHARE_MODE.SCHEDULE || poll.pollShareMode === POLL_SHARE_MODE.SHARE_ALL) {
                    await handleStopAll();
                } else {
                    await handleStop(true);
                }
            }
        } finally {
            setIsSaving(false);
            setModalShow(false);
        }
    }


    return (
        <Modal
            id="form-modal"
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
            dialogClassName= {"save-question-bank-modal"}
        >

            <ModalClose
                tabIndex={0}
                role={BUTTON}
                aria-label={MODAL_CLOSE_TEXT}
                onClick={handleClose}
                className="modal-close"
                style={{width: "24px", height: "24px"}}
            />
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Modal.Title className="modal-title">
                    {isSharing
                        ? END_NOW_MULTI_OPTIONS_TEXT
                        : (poll.pollType === POLL_TYPE.ATTENDANCE ? FINISH_ATTENDANCE : FINISH_POLL)
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{display: "flex", flexDirection: "column", gap: 25, padding: 20, minHeight: isSharing ? 150 : 80}}>
                {isSharing &&
                    <>
                        <span className={classes.description}>
                            {END_NOW_DESCRIPTION_MULTI_OPTIONS}
                        </span>

                        <div className={classes.row}>
                            <span className={settingsClasses.settingLabel}>{END_NOW_OPTIONS_TEXT}</span>
                            <span style={{width: 70}}/>
                            <YuJaRadioBox
                                size={18}
                                labelStyle={{fontSize: 14, fontWeight: "400", lineHeight: 1.6}}
                                label={ENTIRE_POLL_TEXT}
                                checked={selectedOpt === OPTIONS.POLL}
                                onClick={() => setSelectedOpt(OPTIONS.POLL)}
                            />
                            <span style={{width: 40}}/>
                            <YuJaRadioBox
                                size={18}
                                labelStyle={{fontSize: 14, fontWeight: "400", lineHeight: 1.6}}
                                label={isPPTPage() && poll.liveQuestionNo !== parseInt(serialNo)
                                    ? QUESTION_TEXT + " " + poll.liveQuestionNo
                                    : CURRENT_QUESTION_TEXT
                                }
                                checked={selectedOpt === OPTIONS.QUESTION}
                                onClick={() => setSelectedOpt(OPTIONS.QUESTION)}
                            />
                        </div>
                    </>
                }

                {!isSharing &&
                    <span className={classes.description}>
                        {poll.pollType === POLL_TYPE.ATTENDANCE ? FINISH_ATTENDANCE_DESCRIPTION : FINISH_POLL_DESCRIPTION}
                    </span>
                }

            </Modal.Body>
            <Modal.Footer>
                <div
                    style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                    <span style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center", justifyContent: "flex-end", gap: 10
                    }}>
                        <YuJaButton
                            onClick={handleClose}
                            type={"secondary"}
                            style={{
                                width: 80,
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                           {MODAL_CANCEL_TEXT}
                        </YuJaButton>

                        <YuJaButton
                            onClick={handleSave}
                            disabled={isSaving}
                            style={{
                                width: 80,
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                           {isSaving
                               ? <span className={classes.precessingText}>{FINISH_TEXT}</span>
                               : FINISH_TEXT
                           }
                        </YuJaButton>
                    </span>
                </div>
            </Modal.Footer>

        </Modal>
    );
}